// src/pages/ResultPage.js
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import YouAreBlock from "../components/result/YouAreBlock";
import ScoreTable from "../components/result/ScoreTable";
import EscapeMbtiBlock from "../components/result/EscapeMbtiBlock";
import ShareBlock from "../components/result/ShareBlock";
import CoupangAdBlock from "../components/common/CoupangAdBlock"; // 🔹 추가

import "../styles/result.css";

// 🔹 결과 전용 광고 세트 (3덩이)
const RESULT_PAGE_ADS = [
  {
    id: "robot-cleaner",
    href: "https://link.coupang.com/a/c9ZLny",
    imgSrc:
      "https://img3a.coupangcdn.com/image/affiliate/event/promotion/2025/12/02/b75a567d2265000e018ab16e30d9941b.png",
    alt: "쿠팡 로봇청소기 셀렉트샵 프로모션",
  },
  {
    id: "event-banner-1",
    href: "https://link.coupang.com/a/c9ZLny",
    imgSrc:
      "https://img3a.coupangcdn.com/image/affiliate/event/promotion/2025/12/02/b75a567d2265000e018ab16e30d9941b.png",
    alt: "쿠팡 프로모션 배너 2",
  },
  {
    id: "event-banner-2",
    href: "https://link.coupang.com/a/c9ZLny",
    imgSrc:
      "https://img3a.coupangcdn.com/image/affiliate/event/promotion/2025/12/02/b75a567d2265000e018ab16e30d9941b.png",
    alt: "쿠팡 프로모션 배너 3",
  },
];

function ResultPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [revealed, setRevealed] = useState(false);

  const scores = location.state?.scores || null;

  if (!scores) {
    return (
      <div className="result-page">
        <div className="result-card">
          <header className="result-header">
            <span className="result-logo">mmbbttii</span>
          </header>
          <main className="result-main">
            <h1 className="result-title">아직 결과가 없어요.</h1>
            <p className="result-body-text">
              테스트를 먼저 진행한 뒤, 다시 결과 페이지로 와주세요.
            </p>
            <button
              type="button"
              className="result-button"
              onClick={() => navigate("/test")}
            >
              테스트 하러 가기
            </button>
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="result-page">
      <div className="result-card">
        <header className="result-header">
          <span className="result-logo">mmbbttii</span>
          <button
            type="button"
            className="result-button result-button--ghost"
            onClick={() => navigate("/")}
          >
            다시 시작하기
          </button>
        </header>

        <main className="result-main">
          {!revealed ? (
            <section className="result-section">
              <h2 className="result-section-title">결과 보기 전에</h2>
              <p className="result-body-text">
                잠깐 숨 고르고, &apos;결과 보기&apos;를 눌러주세요.
              </p>

              <button
                type="button"
                className="result-button result-button--center-large"
                onClick={() => setRevealed(true)}
              >
                결과 보기
              </button>

              {/* 🔹 버튼 아래 3덩이 쿠팡 광고 */}
              <div style={{ marginTop: "14px" }}>
                <CoupangAdBlock placement="result-pre" ads={RESULT_PAGE_ADS} />
              </div>
            </section>
          ) : (
            <>
              <h1 className="result-title">테스트 결과</h1>

              <div id="result-card-area">
                <YouAreBlock scores={scores} />
                <ScoreTable scores={scores} />
                <EscapeMbtiBlock />
              </div>
              <ShareBlock scores={scores} />
            </>
          )}
        </main>
      </div>
    </div>
  );
}

export default ResultPage;
